<template>
  <div>
    <compFormEdit
      ref="formbase"
      class="margin-layout"
      :formdata="getBase"
      v-model="formData"
      :labelWidth="120"
    ></compFormEdit>
    <vButtonGroup class="text-right">
      <vButton @click="submit" theme="primary">{{
        $t("global.modal.confirm", { defaultValue: "确定" })
      }}</vButton>
      <vButton @click="cancel">{{
        $t("global.common.cancel", { defaultValue: "取消" })
      }}</vButton>
    </vButtonGroup>
    <vLoading loading size="large" transfer v-if="loading"></vLoading>
  </div>
</template>

<script>
import { HttpSaveArea, HttpAreaGetOne } from "@/service/basicdata";
import { mapGetters } from "vuex";

export default {
  props: ["activeid", "type"],
  created() {
    this.getDetail();
  },
  data() {
    return {
      loading: false,
      id: this.activeid,
      formData: {},
      required: [
        {
          required: true,
          message: "该信息不能为空,请填写",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("dictionary", ["getCountryList"]),
    isAdd() {
      return this.type === "add";
    },
    getBase() {
      return [
        {
          label: this.$t("", { defaultValue: "区域名称" }),
          key: "areaName",
          span: 24,
          tag: "vInput",
        },
        {
          label: this.$t("", { defaultValue: "国家" }),
          key: "regionId",
          span: 24,
          tag: "vSelect",
          options: this.getCountryList.map((item) => {
            return {
              value: item.attach.id,
              label: item.label,
            };
          }),
          props: {
            filterable: true,
          },
          query: this.type === "edit",
        },
        {
          label: this.$t("", { defaultValue: "船期(天)" }),
          key: "sailSchedule",
          span: 24,
          tag: "vInputNumber",
          required: false,
          props: {
            min: 0,
            math: "round",
          },
        },
        {
          label: this.$t("fbb.accountmanage.description", {
            defaultValue: "描述",
          }),
          key: "description",
          span: 24,
          required: false,
          tag: "vTextarea",
        },
      ];
    },
  },
  methods: {
    getDetail() {
      if (this.isAdd) return;
      this.loading = true;
      if (this.id) {
        HttpAreaGetOne({ id: this.id })
          .then((res) => {
            this.formData = res.data;
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            this.$VMessage.error(err.message);
          });
      }
    },

    async submit() {
      const valid = await this.$refs.formbase.validate();
      if (!valid) return;
      this.loading = true;
      HttpSaveArea({
        ...this.formData,
      }).then(
        (res) => {
          this.loading = false;
          this.$VMessage.success(
            this.$t("fbb.logistics.cost_add_success", {
              defaultValue: "添加成功",
            })
          );
          this.success();
        },
        (err) => {
          this.loading = false;
          this.$VMessage.error(err.message);
        }
      );
    },

    success() {
      this.$emit("on-close");
      this.$emit("on-update");
      this.$emit("refreshPage");
    },
    cancel() {
      this.$emit("on-close");
    },
  },
};
</script>
